var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5V2H7.5V7.5H2ZM2 14V8.5H7.5V14H2ZM8.5 7.5V2H14V7.5H8.5ZM8.5 14V8.5H14V14H8.5ZM3 6.5H6.5V3H3V6.5ZM9.5 6.5H13V3H9.5V6.5ZM9.5 13H13V9.5H9.5V13ZM3 13H6.5V9.5H3V13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.c3868f08f2d7be2d671e8a3d6f7d7430.svg";
export { ForwardRef as ReactComponent };